import React, { useState, useEffect } from 'react';
import './DropdownInput.css';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
 
const Dropdown = ({ servicerequestnames, handleClickfun }) => {
    const [selectedValue, setSelectedValue] = useState('Select Service Request');
    const [servicerequestnamesOptions, setServicerequestnamesOptions] = useState([]);
    
 
    useEffect(() => {
        setServicerequestnamesOptions(['Select Service Request', ...servicerequestnames]);
        handleClickfun('');
    }, [servicerequestnames]);
 
    const handleSelectChange = (e) => {
        const value = e.target.value;
        if(value==='Select Service Request'){
            toast.error('Please select a valid service request');
            return;
        }
        handleClickfun(value);
        setSelectedValue(value);
    };
 
    return (
        <div>
            <label>
                <select
                    onChange={handleSelectChange}
                    value={selectedValue}
                    className="dropdownButton"
                    

                >
                    {servicerequestnamesOptions.map((item, index) => (
                        <option
                            key={index+1}
                            value={item}
                            disabled={item === 'Select Service Request'}

                        >
                            {item}
                        </option>
                    ))}
                </select>
            </label>
        </div>
    );
};
// PropTypes validation
Dropdown.propTypes = {
    servicerequestnames: PropTypes.array.isRequired,
    handleClickfun: PropTypes.func.isRequired, 
};

 
export default Dropdown;
 